module.exports = __webpack_public_path__ + "static/media/cash-for-junk-car-brisbane.6bf59ed4.png";